import { IAssignedCompetence, IAssignedRole } from "@multiweb/types/contracts";

/**
 * Role s kompetencemi, která obsahuje informaci o aktivnosti.
 */
export interface IRole extends IAssignedRole {
    /**
     * Zda je role aktivní
     */
    active: boolean;

    /**
     * Seznam kompetenčních okruhů přiřazených k této roli
     */
    competenceRanges?: ICompetence[];
}

/**
 * Kompetenční okruh spolu s jeho aktivností.
 */
export interface ICompetence extends IAssignedCompetence {
    /**
     * Zda je okruh aktivní
     */
    active: boolean;
}

/**
 * Asociativní kolekce všech rolí přidělených uživateli, včetně jejich aktivností
 * @param roleID klíčem je id dané role
 */
export interface IRoles {
    [roleID: string]: IRole;
}
